
import { useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UserNamePasswordKeys from 'src/constants/locale/key/UserNamePassword'

export const useTranslations = () => {
  const { translate } = useTranslation([Namespace.USER_NAME_PASSWORD])

  let userId = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.USER_ID
  )

  let emailAddress = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.EMAIL_ADDRESS
  )

  let getSecurityQuestion = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.GET_SECURITY_QUESTION
  )

  let cancel = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.CANCEL
  )

  let forgotPassword = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.FORGOT_PASSWORD
  )

  let submit = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.SUBMIT_BUTTON
  )

  let submitSuccessMessage = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.SUBMIT_SUCCESS_MESSAGE
  )

  let submitErrorMessage = translate(
    Namespace.USER_NAME_PASSWORD,
    UserNamePasswordKeys.SUBMIT_ERROR_MESSAGE
  )

  return {
    userId,
    emailAddress,
    getSecurityQuestion,
    cancel,
    forgotPassword,
    submit,
    submitSuccessMessage,
    submitErrorMessage
  }
}